import React from "react";

import Hero from "@/components/Hero";
import Partners from "@/components/Partners";
import ServicesGrid from "@/components/ServicesGrid";
import WhyChoose from "@/components/WhyChoose";
import Stats from "@/components/Stats";
import Team from "@/components/Team";
import Testimonials from "@/components/Testimonials";

import TrustSection from "@/components/TrustSection";
import CTASection from "@/components/CTASection";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Partners />
      <ServicesGrid />
      <WhyChoose />
      <Stats />

      {/* NEW SECTIONS */}
      <TrustSection />

      <Team />
      <Testimonials />

      <CTASection />
    </>
  );
}